#!/usr/bin/env node

import { execSync } from 'node:child_process';
import { readFileSync, existsSync } from 'node:fs';
import path from 'node:path';
import { generateMcpRoutes } from './generate.js';

const args = process.argv.slice(2);
const command = args[0];

if (command !== 'spec-and-routes') {
  console.error(`[tsoa-mcp] Unknown command: ${command}`);
  console.error('Usage: tsoa-mcp spec-and-routes [--tsoa-config <path>] [...tsoa args]');
  process.exit(1);
}

// Extract --tsoa-config if provided, default to tsoa.json
let tsoaConfigPath = 'tsoa.json';
const passthroughArgs: string[] = [];

for (let i = 1; i < args.length; i++) {
  if (args[i] === '--tsoa-config' && args[i + 1]) {
    tsoaConfigPath = args[++i];
  } else {
    passthroughArgs.push(args[i]);
  }
}

const resolvedTsoaConfig = path.resolve(tsoaConfigPath);

if (!existsSync(resolvedTsoaConfig)) {
  console.error(`[tsoa-mcp] tsoa config not found: ${resolvedTsoaConfig}`);
  process.exit(1);
}

// Step 1: Run tsoa spec-and-routes (passthrough)
console.log('[tsoa-mcp] Running tsoa spec-and-routes...');
const tsoaCmd = `npx tsoa spec-and-routes ${passthroughArgs.join(' ')}`.trim();
try {
  execSync(tsoaCmd, { stdio: 'inherit', cwd: process.cwd() });
} catch {
  console.error('[tsoa-mcp] tsoa spec-and-routes failed');
  process.exit(1);
}

// Step 2: Read tsoa config to find output paths
const tsoaConfig = JSON.parse(readFileSync(resolvedTsoaConfig, 'utf-8'));
const specOutputDir = tsoaConfig.spec?.outputDirectory ?? 'build';
const routesDir = tsoaConfig.routes?.routesDir ?? 'build';
const swaggerPath = path.resolve(specOutputDir, 'swagger.json');
const esm = tsoaConfig.routes?.esm ?? false;

if (!existsSync(swaggerPath)) {
  console.error(`[tsoa-mcp] swagger.json not found at: ${swaggerPath}`);
  process.exit(1);
}

// Step 3: Generate MCP routes
console.log('[tsoa-mcp] Generating MCP routes...');
await generateMcpRoutes({
  swaggerPath,
  routesDir: path.resolve(routesDir),
  esm,
});

console.log('[tsoa-mcp] Done.');
